/**
 * A generic map keyed by strings
 */
export default interface ILookup<U> {
    [key: string]: U;
}

export function newLookupWithStringsNumbersBooleans(): ILookup<string | number | boolean> {
    const result: ILookup<string | number | boolean> = {};
    return result;
}
